/**
 * Application route paths and navigation config.
 * Single source of truth for routing — use these constants instead of hardcoded paths.
 */

/** Base path constants — use these for <Link to={…}> and <Route path={…}> */
export const ROUTES = {
  HOME: "/",
  RESULTS: "/result",
  GALLERY: "/gallery",
  ABOUT_US: "/aboutUs",
  CONTACT_US: "/contactUs",
  APPLY_ONLINE: "/applyOnline",
  ENQUIRY: "/enquiry",
  RULES_AND_REGULATIONS: "/rules&regulations",
  REFUND_AND_CANCELLATION: "/refund&cancellation",
  NOT_FOUND: "*",
};

/** Course route paths (semantic keys, stable paths) */
export const COURSE_ROUTES = {
  XI_FRESHER: "/XI_FRESHER",
  XII_TARGET: "/XII_TARGET",
  VIII_FOUNDATION: "/VIII_FOUNDATION",
  IX_FOUNDATION: "/IX_FOUNDATION",
  X_FOUNDATION: "/X_FOUNDATION",
};

/** All course entries for nav/footer (path + label) */
export const COURSE_LINKS = [
  { path: COURSE_ROUTES.XI_FRESHER, label: "XI Fresher" },
  { path: COURSE_ROUTES.XII_TARGET, label: "XII Target/Ultimate" },
  { path: COURSE_ROUTES.VIII_FOUNDATION, label: "VIII Foundation" },
  { path: COURSE_ROUTES.IX_FOUNDATION, label: "IX Foundation" },
  { path: COURSE_ROUTES.X_FOUNDATION, label: "X Foundation" },
];

/** Main navigation links (path + label) */
export const NAV_LINKS = [
  { path: ROUTES.HOME, label: "Home" },
  { path: ROUTES.RESULTS, label: "Result" },
  { path: ROUTES.GALLERY, label: "Gallery" },
  { path: ROUTES.ABOUT_US, label: "About Us" },
  { path: ROUTES.CONTACT_US, label: "Contact Us" },
];

/** Footer "Useful links" (path + label) */
export const USEFUL_LINKS = [
  { path: ROUTES.ABOUT_US, label: "About MIDAS" },
  { path: ROUTES.ABOUT_US, label: "Directors Message" },
  { path: ROUTES.ABOUT_US, label: "MIDAS system" },
  { path: ROUTES.RESULTS, label: "Result" },
  { path: ROUTES.GALLERY, label: "Gallery" },
];

/** Footer policy/legal links */
export const POLICY_LINKS = {
  RULES: ROUTES.RULES_AND_REGULATIONS,
  REFUND: ROUTES.REFUND_AND_CANCELLATION,
};
